import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { DataService, Query, QueryColumn, QueryObjectsModel } from '@barthauer/abc/core/data';
import { Observable, of } from 'rxjs';
import { concatMap, map } from 'rxjs/operators';
import { ProfileSelectionComponentInfo } from '../profile-selection/profile-selection-component-info';
import { ProfileSettingsService } from './profile-settings.service';

export class UserPersonInfo {
  Id: string;
  FullName: string;
  FirstName: string;
  LastName: string;
  ParentId: string;
  CompanyName: string;
  ImgPortrait: string;
  ImgPortraitId: string;
  EMail: string;
  MobilePhone: string;
  Salutation: string;
}

@Injectable({
  providedIn: 'root',
})
export class UserPersonInfoService {
  currentUserPersonInfo: UserPersonInfo;
  constructor(
    private router: Router,
    private profileSettingsService: ProfileSettingsService,
    private dataService: DataService
  ) {}

  public getCurrentUserPersonInfo(noCache = false): Observable<UserPersonInfo> {
    if ((this.currentUserPersonInfo || !ProfileSelectionComponentInfo.areProfilesSupported(this.router)) && !noCache) {
      return of(this.currentUserPersonInfo);
    } else {
      return this.profileSettingsService.getCurrentProfileSettings().pipe(
        concatMap((settings) => {
          if (!settings?.id) {
            return of(null);
          }
          return this.dataService.executeReadObjectsQuery(this.prepareQueryUserPersonInfo()).pipe(
            map((data: any) => {
              this.currentUserPersonInfo = data[0];
              return this.currentUserPersonInfo;
            })
          );
        })
      );
    }
  }

  private prepareQueryUserPersonInfo(): QueryObjectsModel {
    const queryColumns: Array<QueryColumn> = [
      this.dataService.createQueryColumn('Id', 'Id'),
      this.dataService.createQueryColumn('ref:Id', 'FullName'),
      this.dataService.createQueryColumn('LastName', 'LastName'),
      this.dataService.createQueryColumn('FirstName', 'FirstName'),
      this.dataService.createQueryColumn('ParentId', 'ParentId'),
      this.dataService.createQueryColumn('ref:ParentId', 'CompanyName'),
      this.dataService.createQueryColumn('EMail', 'EMail'),
      this.dataService.createQueryColumn('MobilePhone', 'MobilePhone'),
      this.dataService.createQueryColumn('Salutation', 'Salutation'),
      this.dataService.createQueryColumn('Shorthand', 'Shorthand'),
      this.dataService.createQueryColumn('Department', 'Department'),
      this.dataService.createQueryColumn('Position', 'Position'),

      {
        Name: 'ImgPortrait',
        OPath: "Documents[Designation = 'Portrait'].Object",
        Format: 'Base64Image[400x400]',
      },
      {
        Name: 'ImgPortraitId',
        OPath: "Documents[Designation = 'Portrait'].Id",
      },
    ];
    const mainQuery: Query = new Query();
    mainQuery.ObjectType = 'Person';
    mainQuery.OPath = 'Id = $CurrentUserId';
    mainQuery.Columns = queryColumns;

    const queryDocument: QueryObjectsModel = new QueryObjectsModel();
    queryDocument.ObjectQueries = [mainQuery];

    return queryDocument;
  }
}
